module.exports = __webpack_public_path__ + "static/installationspartner-extraimg3@2x-min-5f90fade3f30bc2aad8aa4fdb3498049.png";